import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import type { SalesItemUnavailableForNewBookingRecord } from '@navio/nsdk';
import { NoddiDialog } from 'noddi-ui-web';
import { ContactUs } from '../../../Common/ContactUs';

type UnavailableModalProps = {
  open: boolean;
  onClose: () => void;
  salesItem: { name: string; salesItemId: number };
  unavailableSalesItems?: SalesItemUnavailableForNewBookingRecord[];
};

export const UnavailableModal = ({ open, onClose, salesItem, unavailableSalesItems }: UnavailableModalProps) => {
  const unavailableSalesItem = unavailableSalesItems?.find(
    (unavailableSalesItem) => unavailableSalesItem.salesItemId === salesItem.salesItemId
  );
  return (
    <NoddiDialog title={t`Unavailable combination`} onClose={onClose} open={open}>
      <div className='flex flex-col gap-4'>
        <div>
          <span className='font-semibold'>{salesItem.name}</span>{' '}
          <Trans>is currently not offered together with the following services:</Trans>
        </div>
        <ul className='flex flex-col gap-1'>
          {unavailableSalesItem?.conflictingSelectedSalesItems.map((item, idx) => (
            <li key={item.name + idx}>
              <p className='font-semibold'>{item.name}</p>
            </li>
          ))}
        </ul>
        <div>
          <span>
            <Trans>To book this combination, please create two separate bookings.</Trans>
          </span>{' '}
          <ContactUs />
        </div>
      </div>
    </NoddiDialog>
  );
};
